export const documentationRouteNames = {
  TASKS: 'tasks',
  FUNCTIONS: 'functions',
  TASK_EDIT: 'task',
  REPORT: 'report',
  REPORTS: 'reports'
};
